import { baseApi } from 'app/services/baseApi';
import { FileResponse, FilesResponse } from './filesTypes';

const filesApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getAllFiles: builder.query<FilesResponse, string | undefined>({
      query: queryParams => {
        const url = `file` + (queryParams ? `?${queryParams}` : '');
        return {
          url,
          method: 'GET',
        };
      },
      providesTags: ['file'],
    }),
    getFile: builder.query<FileResponse, number>({
      query: id => {
        return {
          url: `file/${id}`,
          method: 'GET',
        };
      },
      providesTags: ['file'],
    }),
    postFile: builder.mutation<Partial<FileResponse>, unknown>({
      query: ({ ...data }) => {
        return {
          url: 'file/uploadFile',
          body: data,
          method: 'POST',
        };
      },
    }),
    deleteFile: builder.mutation<void, number>({
      query: id => {
        return {
          url: `file/${id}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['file'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetAllFilesQuery, usePostFileMutation, useGetFileQuery, useDeleteFileMutation } = filesApi;
